import './Skeleton.css';
import SkeletonDelay from './SkeletonDelay';

export function Skeleton({ className, ...props }) {
  return (
    <SkeletonDelay><div
      aria-hidden="true"
      className={`skeleton ${className || ''}`}
      {...props}
    /></SkeletonDelay>
  );
}

export default Skeleton;
